import { render, staticRenderFns } from "./BaseImport.vue?vue&type=template&id=d3833396&"
import script from "./BaseImport.vue?vue&type=script&lang=js&"
export * from "./BaseImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports